import { useQuery } from '@tanstack/react-query';
import { fileService } from '../services/fileService';

export function useSharedFiles() {
  return useQuery({
    queryKey: ['files', 'shared-with-me'],
    queryFn: () => fileService.getSharedFiles(),
  });
}
